import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {Router, ActivatedRoute} from '@angular/router';
import {PagedListOfAgency, SystemData, User, UserType} from '../../../services/api.client';
import {splitCamelCase} from '../../../utilities/Util';
import {ITableHeader, TableComponent} from '../../shared/table/TableComponent';
import {Agency} from '../../../services/api.client';
import {PledgeType} from '../../../services/api.client';

import {AgencyService} from '../../../services/AgencyService';
import {PledgeTypeService} from '../../../services/PledgeTypeService';
import {DropdownValue} from '../../../utilities/DropdownComponent';
import {AgencyStatusType} from '../../../services/api.client';
import {delay, filter} from 'rxjs/operators';
import {SecurityService} from '../../../services/SecurityService';
// shared
// store
// models
// services
// utilities

@Component({
    templateUrl: './AgencyListComponent.html',
    styleUrls: ['./AgencyListComponent.scss'],
    standalone: false
})

export class AgencyListComponent implements OnInit, AfterViewInit {

  constructor(private _agencyService: AgencyService,
              private _pledgeTypeService: PledgeTypeService,
              private _route: ActivatedRoute,
              private _router: Router,
              private _securityService: SecurityService) {
    this.currentUser$ = this._securityService.currentUser$;
    this.systemData$ = this._securityService.systemData$;
    this.pledgeTypes$ = this._pledgeTypeService.allPledgeTypes$;
  }

  get queryParams(): any {
    return this.params;
  }
  isLoading: boolean;
  pledgeTypeId = '';
  searchValue = '';
  tableHeaders: ITableHeader[];
  params: any;

  @ViewChild(TableComponent)
  table: TableComponent;

  // subscription
  systemData: SystemData;
  systemData$: Observable<SystemData>;
  currentUser: User;
  currentUser$: Observable<User>;
  pledgeTypes: PledgeType[];
  pledgeTypes$: Observable<PledgeType[]>;

  // page-local search results (003-retire-ngrx: results must not outlive the
  // search criteria fields on this component)
  pagedList: PagedListOfAgency;
  agencies: Agency[];

  // sorting
  currentSortName = 'AgencyName';
  currentSorting = false;


  // PAGINATION
  limit = 10;
  currentPage = 1;
  maxSize = 1;
  totalCount: number;

  // Dropdowns
  pledgeTypeDropdown: DropdownValue[];

  ngAfterViewInit(): void {
    this._route.params
      .pipe(delay(0)) // fixes expression has changed after it was checked.
      .subscribe(params => {
      this.searchValue = params.searchValue || '';
      this.pledgeTypeId = params.pledgeTypeId || '';
      this.limit = +params.limit || 10;
      this.currentPage = +params.currentPage || 1;
      this.params = {
        searchValue: this.searchValue,
        pledgeTypeId: this.pledgeTypeId,
        limit: this.limit,
        includeDisable: true,
        sortName: this.currentSortName,
        descending: this.currentSorting,
        currentPage: this.currentPage,
      };
      const request = this._agencyService.getAgencies(
        this.searchValue,
        this.pledgeTypeId,
        true,
        this.limit,
        this.currentSortName,
        this.currentSorting,
        (this.currentPage - 1) * this.limit
      );
      this.table.request = request;
      request.subscribe({
        next: (pagedList) => {
          this.pagedList = pagedList;
          this.agencies = pagedList?.items;
          this.totalCount = pagedList?.totalCount;
        }, error: () => {} // service already toasts the failure
      });
    });
  }

  ngOnInit(): void {
    this.currentUser$.subscribe(user => this.currentUser = user);
    this.systemData$.subscribe(systemData => this.systemData = systemData);
    this.pledgeTypes$.subscribe(pledgeTypes => this.pledgeTypes = pledgeTypes);
    this.tableHeaders = [
      {text: 'Agency Name', sortKey: 'AgencyName', ascending: true},
    ];
    // add additional columns for admin user
    if (this.currentUser.userType === UserType.SystemAdmin) {
      this.tableHeaders.push({text: 'Status', sortKey: 'Status'});
    }
    this.loadPledgeTypes();
  }

  // Current Selected Agency
  setCurrentSelectedAgency(agency: Agency): void {
    this._agencyService.setCurrentSelectedAgency(agency);
  }

  sortAgencies(options: ITableHeader): void {
    this.currentSortName = options.sortKey;
    this.currentSorting = !options.ascending;
    this.filterAgencies();
  }

  // pagination methods
  setLimit(limit: number): void {// # of rows per page
    this.limit = limit;
    this.filterAgencies();
  }

  setPage(page: number): void {
    setTimeout(() => {
      this.currentPage = page; // set current page
      this.filterAgencies();
    });
  }

  // set selected Pledge Type ID
  selectedPledgeType(pledgeType): void {
    this.pledgeTypeId = pledgeType;
  }

  // dropdown - pledge types (shared reference cache; fetch only if not yet loaded)
  loadPledgeTypes(): void {// get Pledge Types
    this.pledgeTypes$.pipe(
      filter(pledgeTypes => !pledgeTypes))
      .subscribe(() => {
        this._pledgeTypeService.getAllPledgeTypes();
      });
    this.pledgeTypes$.subscribe(() => {
      // set Pledge Types drop-down
      if (this.pledgeTypes) {
        this.pledgeTypeDropdown = [];
        for (const pledgeType of this.pledgeTypes) {
          this.pledgeTypeDropdown.push(new DropdownValue(pledgeType.id, pledgeType.name));
        }
      }
    });
  }

  filterAgencies(): void {// get agencies
    this._router.navigate(['/app/agencies', {
      searchValue: this.searchValue,
      pledgeTypeId: this.pledgeTypeId,
      includeDisabled: true,
      limit: this.limit,
      sortName: this.currentSortName,
      descending: this.currentSorting,
      currentPage: this.currentPage,
    }]).then();
  }

  // search value
  setSearchValue(searchValue): void {
    this.searchValue = searchValue;
  }

    // format Agency Status
    formatAgencyStatus(status: AgencyStatusType): string {
      if (!status || !status.toString().trim()) {
          return 'missing status';
      }

      return splitCamelCase(status.toString() || 'missing status', true);
    }
}
